import React from 'react';
import {genericHashLink} from "react-router-hash-link";
import GatsbyLink from "gatsby-link";


const ScrollHashAnchor = (props) => genericHashLink(props, GatsbyLink);


export default ScrollHashAnchor;
